import {
  Alert,
  Box,
  Button,
  DialogActions,
  FormControl,
  LinearProgress,
  TextField,
} from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { BulkActionProps } from './props.interface';
import { ErrorsFlattenner } from '../errors-flattenner/errors-flattenner';
import { isMobile, isTablet } from 'react-device-detect';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { useSnackBar } from '../../../contexts/snackbar';

function RestoreOrdersAction({
  selectedOrders,
  refetchOrders,
  onFinishAction
}: BulkActionProps  & {  onFinishAction: ()=>void;}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>('');
  const [response, setResponse] = React.useState<AxiosResponse>();
  const {showMessage} = useSnackBar()

  const {  config } = useContext(AuthContext);

  const handleSubmit = async () => {
    const endpoint = `${API_ENDPOINT}/v1/orders/restore/`;

    setIsLoading(true);
    setMessage('');
    setResponse(undefined);
    const requestData = {
        order_ids: Array.from(selectedOrders.values()).map(item => item.id)
    }

    try {
      const response = await axios.post<OrderType[]>(endpoint, requestData, config)
      setResponse(response);
      showMessage("Orders restored successfully");
      setMessage('Orders restored successfully');
      refetchOrders();
      onFinishAction();
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to restore orders: ' + e.response?.statusText);
      } else {
        setMessage('Failed to restore orders');
      }
    }
    setIsLoading(false);
  };

  console.log(response);

  return (
    <>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <>
          {message != '' && (
            <>
              <Alert
                severity={
                  response && response.status >= 200 && response.status < 300
                    ? 'success'
                    : 'error'
                }
              >
                <>
                  {message}

                  {response && response.status >= 300 && (
                    <ErrorsFlattenner rawErrors={response.data} />
                  )}
                </>
              </Alert>
              <br />{' '}
            </>
          )}
          <Alert severity='info'>
            Are you sure you want to restore the selected {selectedOrders.size} orders?
          </Alert>
          <Box justifyContent={"center"} mt={2} display={"flex"}>
            <Button
              size={(isMobile && !isTablet) ? 'small' : 'medium'}
              disabled={isLoading}
              variant="contained"
              type="submit"
              onClick={handleSubmit}
            >
              {' '}
              Restore Orders
            </Button>
           </Box>
            
        </>
      )}
    </>
  );
}

export default RestoreOrdersAction;
